module.exports = __webpack_public_path__ + "static/media/Template_33.56e9007b.png";